import React from 'react';
import StandingsRow from 'app/components/standings/StandingsRow';
import {Placeholder} from '@fupa/fupa-uikit';

const LeagueStanding = ({standings, gameType = 'league', view}) => {
  if (standings.length) {
    return (
      <>
        {standings.map(team =>
          team.team ? <StandingsRow key={team.team?.id} team={team} gameType={gameType} view={view} /> : null
        )}
      </>
    );
  } else {
    return <Placeholder>Keine Daten vorhanden.</Placeholder>;
  }
};

export {LeagueStanding};
